import { HERO_IMG, PHOTO } from "@/data/site";

export const pressoterapiaData = {
    hero: {
        eyebrow: "Pressoterapia professionale a Livorno",
        title: ["Pressoterapia", "a Livorno."],
        subtitle:
            "Un trattamento drenante delicato e rilassante che favorisce il benessere delle gambe e dona una piacevole sensazione di leggerezza.",
        subtitleMobile: "Drenaggio delicato e sensazione di leggerezza.",
        imgD: HERO_IMG.pressoterapia.d,
        imgM: HERO_IMG.pressoterapia.m,
    },
    marquee: ["Drenaggio", "Leggerezza", "Benessere", "Ritmo", "Relax"],
    intro: {
        number: "01",
        eyebrow: "Che cos'è",
        title: "Un trattamento drenante che accompagna il naturale ritmo del corpo.",
        body: [
            "La pressoterapia è un trattamento estetico che utilizza una pressione controllata e sequenziale per stimolare il naturale drenaggio dei liquidi presenti nei tessuti.",
            "Durante la seduta vengono indossati appositi gambali collegati a un macchinario che esercita una compressione graduale. Il massaggio pneumatico segue un ritmo preciso, studiato per accompagnare il normale ritorno venoso e linfatico.",
            "Si tratta di un trattamento non invasivo, rilassante e particolarmente apprezzato da chi desidera prendersi cura del proprio corpo attraverso un percorso dedicato al benessere.",
        ],
    },
    how: {
        number: "02",
        eyebrow: "Come funziona",
        title: "Un massaggio ritmico che segue il tuo respiro.",
        image: PHOTO.pressoterapia,
        imageAlt: "Pressoterapia",
        body: [
            "La seduta si svolge in un ambiente tranquillo e confortevole. Dopo aver indossato gli appositi gambali, il dispositivo inizia a esercitare una pressione graduale seguendo una sequenza programmata.",
            "La compressione si alterna a momenti di rilascio, creando un massaggio ritmico che accompagna il naturale movimento dei liquidi corporei.",
            "L'intensità del trattamento viene impostata in base alle esigenze della persona, rendendo ogni seduta piacevole e personalizzata.",
        ],
    },
    benefits: {
        eyebrow: "I benefici",
        title: "Ritrovare leggerezza, respirare comfort.",
        subtitle:
            "Inserita all'interno di un percorso personalizzato e accompagnata da uno stile di vita equilibrato, la pressoterapia può contribuire a migliorare il comfort quotidiano.",
        items: [
            {
                title: "Favorisce il drenaggio dei liquidi",
                body: "La pressoterapia favorisce il naturale drenaggio dei liquidi presenti nei tessuti, regalando una piacevole sensazione di leggerezza dopo giornate trascorse molte ore in piedi o sedute.",
            },
            {
                title: "Contrasta la sensazione di gambe pesanti",
                body: "Un valido trattamento estetico per chi desidera concedersi un momento dedicato al benessere e ritrovare una maggiore sensazione di comfort.",
            },
            {
                title: "Un momento rilassante e piacevole",
                body: "Il massaggio pneumatico esercitato dai gambali crea una compressione graduale e uniforme, spesso percepita come piacevole e distensiva.",
            },
            {
                title: "Un valido supporto nei percorsi estetici",
                body: "Può essere affiancata ad altri trattamenti professionali per offrire un programma personalizzato, sempre dopo una consulenza dedicata.",
            },
        ],
    },
    whenAdvised: {
        eyebrow: "Consigliato",
        title: "La pressoterapia è il trattamento giusto per te?",
        subtitle:
            "Ogni corpo è diverso e non esiste un trattamento uguale per tutti. Preferiamo consigliarti solo ciò che riteniamo realmente adatto alle tue esigenze.",
        cards: [
            {
                title: "È indicata se…",
                list: [
                    "avverti spesso una sensazione di gambe pesanti;",
                    "desideri favorire il drenaggio dei liquidi;",
                    "soffri di ritenzione idrica;",
                    "vuoi prenderti cura del benessere delle gambe;",
                    "cerchi un trattamento rilassante e non invasivo;",
                    "desideri inserirla in un percorso estetico personalizzato.",
                ],
            },
            {
                title: "Quando chiedere una consulenza",
                body: "In presenza di particolari condizioni di salute è sempre opportuno confrontarsi preventivamente con il proprio medico. Durante la consulenza iniziale valuteremo insieme le tue esigenze e ti forniremo tutte le informazioni necessarie.",
            },
        ],
    },
    whyUs: {
        number: "03",
        eyebrow: "Perché Spazio Isa",
        title: "Un rapporto di fiducia costruito nel tempo.",
        image: PHOTO.donnaRilassata,
        imageAlt: "Ambiente Spazio Isa",
        body: [
            "Da oltre quindici anni Spazio Isa accoglie ogni cliente con professionalità, disponibilità e attenzione ai dettagli, offrendo un ambiente riservato e rilassante.",
            "Ogni seduta viene svolta con cura, rispettando le esigenze della persona e adattando il trattamento in base agli obiettivi condivisi durante la consulenza.",
            "Crediamo che il valore di un centro estetico non dipenda soltanto dalle tecnologie, ma soprattutto dalla qualità del rapporto che si crea con ogni cliente.",
        ],
    },
    ctaTitle: "Prenota la tua seduta di pressoterapia.",
    ctaSubtitle:
        "Se desideri ricevere maggiori informazioni sulla pressoterapia o vuoi capire se questo trattamento è adatto alle tue esigenze, saremo felici di accoglierti.",
    faq: [
        {
            q: "Che cos'è la pressoterapia?",
            a: "La pressoterapia è un trattamento estetico che utilizza una pressione controllata esercitata attraverso appositi gambali per favorire il naturale drenaggio dei liquidi e regalare una piacevole sensazione di leggerezza.",
        },
        {
            q: "Quanto dura una seduta di pressoterapia?",
            a: "La durata può variare in base al percorso personalizzato. Durante la consulenza iniziale ti forniremo tutte le informazioni sul trattamento e sui tempi previsti.",
        },
        {
            q: "La pressoterapia è dolorosa?",
            a: "No. La seduta è generalmente percepita come piacevole e rilassante. La pressione viene regolata in modo da garantire comfort durante tutto il trattamento.",
        },
        {
            q: "Quante sedute sono consigliate?",
            a: "Il numero di sedute dipende dagli obiettivi e dalla valutazione effettuata durante la consulenza. In molti casi viene consigliato un percorso composto da più appuntamenti.",
        },
        {
            q: "Posso abbinare la pressoterapia ad altri trattamenti?",
            a: "Sì. La pressoterapia può essere inserita all'interno di un percorso estetico personalizzato insieme ad altri trattamenti proposti da Spazio Isa.",
        },
        {
            q: "Ci sono situazioni in cui non è consigliata?",
            a: "Sì. In presenza di particolari condizioni di salute è importante confrontarsi preventivamente con il proprio medico.",
        },
        {
            q: "Dove si trova Spazio Isa?",
            a: "Il centro estetico Spazio Isa si trova in Via A. Minghi 30, nel quartiere Coteto, a Livorno.",
        },
    ],
    related: [
        { label: "Estetica", to: "/estetica" },
        { label: "Radiofrequenza", to: "/radiofrequenza" },
        { label: "Infrarossi", to: "/infrarossi" },
        { label: "Epilazione Laser", to: "/laser" },
        { label: "Prodotti", to: "/prodotti" },
        { label: "Contatti", to: "/contatti" },
    ],
};

export const laserData = {
    hero: {
        eyebrow: "Epilazione laser professionale a Livorno",
        title: ["Epilazione Laser", "a Livorno."],
        subtitle:
            "Un percorso personalizzato per ridurre progressivamente i peli e vivere la cura della pelle con maggiore praticità e serenità.",
        subtitleMobile: "Riduzione progressiva dei peli, con cura.",
        imgD: HERO_IMG.laser.d,
        imgM: HERO_IMG.laser.m,
    },
    marquee: ["Riduzione", "Praticità", "Percorso", "Delicatezza"],
    intro: {
        number: "01",
        eyebrow: "Cos'è",
        title: "Una soluzione pensata per ridurre progressivamente i peli.",
        body: [
            "L'epilazione laser è un trattamento estetico scelto da chi desidera intervenire in modo più duraturo sulla presenza dei peli superflui, riducendo progressivamente la ricrescita attraverso un percorso composto da più sedute.",
            "Viene spesso chiamata anche 'depilazione definitiva', ma è più corretto parlare di epilazione laser e di riduzione progressiva dei peli. Il risultato può variare in base a caratteristiche individuali.",
            "Da Spazio Isa ogni percorso inizia con un momento di ascolto e valutazione: caratteristiche della pelle, del pelo e della zona interessata, per proporre un trattamento adatto alle reali esigenze.",
        ],
    },
    how: {
        number: "02",
        eyebrow: "Come funziona",
        title: "Un fascio di luce selettiva, calibrato su di te.",
        image: PHOTO.laserGambe,
        imageAlt: "Epilazione laser",
        body: [
            "L'epilazione laser utilizza un fascio di luce selettivo che viene assorbito dalla melanina presente nel pelo. L'energia luminosa si trasforma in calore e raggiunge il follicolo pilifero.",
            "Il trattamento risulta particolarmente efficace quando il pelo si trova nella fase attiva di crescita. È per questo che sono necessarie più sedute, distribuite nel tempo.",
            "Le impostazioni vengono adattate in base alle caratteristiche della pelle e del pelo, evitando parametri uguali per tutte.",
        ],
    },
    scope: {
        number: "03",
        eyebrow: "Zone trattabili",
        title: "Un percorso costruito sulle caratteristiche della persona.",
        image: PHOTO.curaPelle,
        imageAlt: "Cura della pelle",
        body: [
            "Ogni pelle ha caratteristiche differenti e ogni zona del corpo può rispondere in modo diverso. Per questo valutiamo: colore della pelle, colore e spessore del pelo, quantità, zona da trattare, frequenza della ricrescita e obiettivi personali.",
            "Non esiste un numero di sedute valido per tutte. Da Spazio Isa preferiamo spiegare ogni fase con chiarezza, senza promettere risultati identici o immediati.",
        ],
    },
    benefits: {
        eyebrow: "I vantaggi",
        title: "Semplificare la cura della pelle, seduta dopo seduta.",
        subtitle:
            "Scegliere un percorso di epilazione laser significa cercare una soluzione più pratica rispetto alla depilazione frequente con ceretta o rasoio.",
        items: [
            {
                title: "Riduce progressivamente la ricrescita",
                body: "I peli possono diventare meno numerosi, più sottili e meno visibili nel corso del percorso. Il risultato non è immediato: è la costanza a permettere di osservare l'evoluzione.",
            },
            {
                title: "Semplifica la cura quotidiana",
                body: "Ridurre progressivamente i peli può rendere la gestione quotidiana più semplice e diminuire il tempo dedicato alla depilazione tradizionale.",
            },
            {
                title: "Aiuta a limitare fastidi",
                body: "Ceretta e rasoio possono provocare irritazioni. L'epilazione laser rappresenta un'alternativa per chi desidera ridurre gradualmente la frequenza di questi metodi.",
            },
            {
                title: "Diverse zone del viso e del corpo",
                body: "L'epilazione laser può essere valutata per diverse aree, dalle zone più piccole del viso fino a superfici più ampie del corpo.",
            },
            {
                title: "Una sensazione di libertà",
                body: "Per molte donne il beneficio più apprezzato è sentirsi più libere nelle proprie abitudini, senza organizzare continuamente depilazioni.",
            },
            {
                title: "Un'esperienza dedicata",
                body: "L'ambiente del centro è pensato per offrire tranquillità e riservatezza, trasformando ogni appuntamento in un momento dedicato a te.",
            },
        ],
    },
    whenAdvised: {
        eyebrow: "Consigliato",
        title: "L'epilazione laser è il trattamento giusto per te?",
        subtitle:
            "Prima di iniziare valutiamo insieme fototipo della pelle, colore del pelo, zona da trattare e obiettivi desiderati.",
        cards: [
            {
                title: "Può essere indicata se…",
                list: [
                    "desideri ridurre progressivamente i peli;",
                    "sei stanca della depilazione frequente;",
                    "utilizzi regolarmente ceretta o rasoio;",
                    "vuoi semplificare la gestione della depilazione;",
                    "cerchi un percorso personalizzato in un centro professionale.",
                ],
            },
            {
                title: "Quando è importante una valutazione",
                body: "Comunica sempre eventuali condizioni particolari, terapie farmacologiche, sensibilità della pelle o cambiamenti recenti. In alcune situazioni potrebbe essere opportuno rimandare il trattamento o richiedere il parere del medico.",
            },
        ],
    },
    whyUs: {
        number: "04",
        eyebrow: "Perché Spazio Isa",
        title: "Un rapporto di fiducia, dall'inizio al percorso.",
        image: PHOTO.dialogo,
        imageAlt: "Consulenza Spazio Isa",
        body: [
            "Da oltre quindici anni Spazio Isa accoglie le proprie clienti con attenzione, disponibilità e professionalità, dedicando il tempo necessario ad ascoltare ogni esigenza.",
            "Ogni percorso viene personalizzato perché ogni pelle e ogni pelo hanno caratteristiche differenti. Preferiamo costruire un programma su misura piuttosto che proporre soluzioni standard.",
            "Il nostro obiettivo non è soltanto eseguire un trattamento, ma creare un rapporto di fiducia che permetta a ogni cliente di sentirsi seguita con competenza e trasparenza.",
        ],
    },
    ctaTitle: "Prenota la tua consulenza per l'epilazione laser.",
    ctaSubtitle:
        "Durante la consulenza analizzeremo la zona, le caratteristiche della pelle e del pelo e ti spiegheremo come si sviluppa il percorso.",
    faq: [
        {
            q: "L'epilazione laser è la stessa cosa della depilazione definitiva?",
            a: "Molte persone utilizzano il termine 'depilazione definitiva', ma è più corretto parlare di epilazione laser finalizzata alla riduzione progressiva dei peli. I risultati possono variare da persona a persona.",
        },
        {
            q: "Quante sedute sono necessarie?",
            a: "Il numero di sedute dipende dalla zona trattata, dal tipo di pelo e dalla risposta individuale. Durante la consulenza iniziale verrà definito un percorso personalizzato.",
        },
        {
            q: "Il trattamento è doloroso?",
            a: "La percezione è soggettiva e può variare in base alla sensibilità e alla zona. Durante ogni seduta il trattamento viene eseguito con attenzione per garantire il massimo comfort possibile.",
        },
        {
            q: "Posso espormi al sole durante il percorso?",
            a: "Prima e dopo le sedute è importante seguire le indicazioni fornite durante la consulenza. Una corretta gestione dell'esposizione solare contribuisce a proteggere la pelle.",
        },
        {
            q: "Quali zone possono essere trattate?",
            a: "L'epilazione laser può essere eseguita su diverse aree del viso e del corpo, tra cui baffetto, mento, ascelle, braccia, gambe, inguine, addome e schiena.",
        },
        {
            q: "Posso fare la ceretta durante il percorso?",
            a: "Generalmente no. Durante il percorso è importante evitare metodi che rimuovono il pelo dalla radice, come ceretta o pinzetta.",
        },
        {
            q: "Dove si trova Spazio Isa?",
            a: "Spazio Isa si trova in Via A. Minghi 30, nel quartiere Coteto, a Livorno.",
        },
    ],
    related: [
        { label: "Estetica", to: "/estetica" },
        { label: "Pressoterapia", to: "/pressoterapia" },
        { label: "Radiofrequenza", to: "/radiofrequenza" },
        { label: "Infrarossi", to: "/infrarossi" },
        { label: "Prodotti", to: "/prodotti" },
        { label: "Contatti", to: "/contatti" },
    ],
};

export const infrarossiData = {
    hero: {
        eyebrow: "Trattamento viso anti-age e rassodante a Livorno",
        title: ["Infrarossi Viso", "a Livorno."],
        subtitle:
            "Un trattamento dedicato alla cura del viso, pensato per sostenere tonicità, luminosità e benessere della pelle con delicatezza.",
        subtitleMobile: "Tonicità, luminosità, delicatezza per la pelle.",
        imgD: HERO_IMG.infrarossi.d,
        imgM: HERO_IMG.infrarossi.m,
    },
    marquee: ["Tonicità", "Luminosità", "Benessere", "Cura"],
    intro: {
        number: "01",
        eyebrow: "Un trattamento dedicato",
        title: "Un trattamento dedicato alla bellezza e al benessere del viso.",
        body: [
            "Il viso racconta molto di noi. La stanchezza, i cambiamenti stagionali, lo stress e il trascorrere del tempo possono rendere la pelle meno luminosa, meno uniforme e visibilmente meno tonica.",
            "Il trattamento agli infrarossi è pensato per chi desidera dedicare maggiore attenzione alla propria pelle attraverso un percorso estetico delicato, piacevole e personalizzato.",
            "Il nostro approccio parte dalla valorizzazione della bellezza naturale e dal desiderio di aiutare ogni cliente a sentirsi più a proprio agio con la propria immagine.",
        ],
    },
    how: {
        number: "02",
        eyebrow: "Come funziona",
        title: "Una piacevole sensazione di calore, controllata con cura.",
        image: PHOTO.infrarossi,
        imageAlt: "Trattamento infrarossi",
        body: [
            "Il trattamento utilizza l'azione degli infrarossi per generare una piacevole sensazione di calore sulla zona trattata. Il calore viene applicato in modo graduale e controllato.",
            "La sensazione percepita è generalmente piacevole e rilassante. Il calore contribuisce a rendere il trattamento confortevole e trasforma l'appuntamento in un momento di distensione.",
            "Non utilizziamo programmi standard uguali per tutte. Preferiamo valutare ogni situazione individualmente e consigliare il numero e la frequenza delle sedute in base alle reali esigenze.",
        ],
    },
    benefits: {
        eyebrow: "I benefici",
        title: "Un rituale che accompagna la pelle nel tempo.",
        subtitle:
            "I benefici vengono valutati in base alla risposta individuale della pelle e possono essere più apprezzabili quando il trattamento viene inserito in un percorso costante e personalizzato.",
        items: [
            {
                title: "Sostiene la tonicità della pelle",
                body: "Il trattamento agli infrarossi viene utilizzato come supporto estetico nei percorsi dedicati alla tonicità e alla cura dell'aspetto del viso.",
            },
            {
                title: "Favorisce un aspetto più luminoso",
                body: "Il viso può apparire più curato, luminoso e disteso, soprattutto quando accompagnato da una corretta routine cosmetica domiciliare.",
            },
            {
                title: "Accompagna i percorsi anti-age",
                body: "Il suo valore risiede nella possibilità di prendersi cura della pelle con costanza, attraverso sedute programmate in base alle esigenze individuali.",
            },
            {
                title: "Una piacevole sensazione di calore",
                body: "Il calore degli infrarossi rende la seduta particolarmente piacevole e favorisce una sensazione di comfort e distensione.",
            },
            {
                title: "Valorizza la bellezza naturale",
                body: "Il trattamento viene proposto per migliorare l'aspetto complessivo della pelle, valorizzandone la luminosità senza alterare l'identità della persona.",
            },
            {
                title: "Un momento tutto per te",
                body: "Molte clienti descrivono la seduta come un piccolo spazio personale, in cui sentirsi accolte, ascoltate e seguite con attenzione.",
            },
        ],
    },
    whenAdvised: {
        eyebrow: "Consigliato",
        title: "Il trattamento agli infrarossi è adatto a te?",
        subtitle:
            "Ogni pelle è diversa e reagisce in modo personale ai trattamenti estetici. Prima di iniziare qualsiasi percorso, effettuiamo una consulenza dedicata.",
        cards: [
            {
                title: "Può essere indicato se…",
                list: [
                    "desideri prenderti cura della pelle del viso;",
                    "vuoi sostenere tonicità ed elasticità cutanea;",
                    "cerchi di migliorare l'aspetto di una pelle spenta;",
                    "vuoi inserire un trattamento anti-age nella tua routine;",
                    "desideri concederti un momento di relax e benessere.",
                ],
            },
            {
                title: "Quando è consigliata una valutazione",
                body: "Prima di iniziare comunica eventuali sensibilità della pelle, trattamenti dermatologici in corso o altre condizioni particolari. In alcuni casi potrebbe essere opportuno richiedere il parere del proprio medico.",
            },
        ],
    },
    whyUs: {
        number: "03",
        eyebrow: "Perché Spazio Isa",
        title: "Ogni pelle ha una storia. Vogliamo ascoltarla.",
        image: PHOTO.curaViso2,
        imageAlt: "Cura del viso Spazio Isa",
        body: [
            "Da oltre quindici anni Spazio Isa accoglie ogni cliente con competenza, disponibilità e attenzione ai dettagli.",
            "Ogni trattamento viene personalizzato in base alle caratteristiche della pelle e agli obiettivi desiderati, senza seguire protocolli standard uguali per tutte.",
            "Accompagniamo ogni cliente durante tutto il percorso, fornendo consigli personalizzati e suggerendo, quando necessario, i prodotti cosmetici più adatti.",
        ],
    },
    ctaTitle: "Prenota il tuo trattamento viso agli infrarossi.",
    ctaSubtitle:
        "Durante la consulenza analizzeremo le caratteristiche della tua pelle e costruiremo insieme il percorso più adatto alle tue esigenze.",
    faq: [
        {
            q: "Che cosa sono gli infrarossi per il viso?",
            a: "Un trattamento estetico che utilizza il calore generato dagli infrarossi come supporto ai percorsi dedicati alla cura della pelle, alla luminosità e alla tonicità del viso.",
        },
        {
            q: "Il trattamento è doloroso?",
            a: "No. Generalmente il trattamento è ben tollerato e viene percepito come una piacevole sensazione di calore.",
        },
        {
            q: "Quante sedute sono consigliate?",
            a: "Il numero delle sedute dipende dalle caratteristiche della pelle e dagli obiettivi della cliente. Durante la consulenza verrà proposto un percorso personalizzato.",
        },
        {
            q: "È adatto a tutte le età?",
            a: "Può essere preso in considerazione da chi desidera prendersi cura della pelle. La consulenza iniziale permette di valutare il trattamento più indicato per ogni persona.",
        },
        {
            q: "Posso abbinarlo ad altri trattamenti viso?",
            a: "Sì. Il trattamento può essere inserito in un percorso estetico personalizzato insieme ad altri trattamenti proposti da Spazio Isa.",
        },
        {
            q: "Quando iniziano a vedersi i risultati?",
            a: "La risposta della pelle varia da persona a persona. I benefici possono essere più apprezzabili seguendo con costanza il percorso consigliato.",
        },
        {
            q: "Dove si trova Spazio Isa?",
            a: "In Via A. Minghi 30, nel quartiere Coteto, a Livorno.",
        },
    ],
    related: [
        { label: "Estetica", to: "/estetica" },
        { label: "Radiofrequenza", to: "/radiofrequenza" },
        { label: "Pressoterapia", to: "/pressoterapia" },
        { label: "Epilazione Laser", to: "/laser" },
        { label: "Prodotti", to: "/prodotti" },
        { label: "Contatti", to: "/contatti" },
    ],
};

export const radiofrequenzaData = {
    hero: {
        eyebrow: "Trattamento viso rassodante e anti-age a Livorno",
        title: ["Radiofrequenza", "Viso, a Livorno."],
        subtitle:
            "Un trattamento mirato per prendersi cura delle rughe più marcate e sostenere tonicità, compattezza e naturale bellezza del viso.",
        subtitleMobile: "Cura delle rughe, tonicità del viso.",
        imgD: HERO_IMG.radiofrequenza.d,
        imgM: HERO_IMG.radiofrequenza.m,
    },
    marquee: ["Tonicità", "Compattezza", "Anti-age", "Cura"],
    intro: {
        number: "01",
        eyebrow: "Che cos'è",
        title: "Un trattamento mirato per le rughe più marcate del viso.",
        body: [
            "Con il trascorrere del tempo la pelle può perdere gradualmente tonicità, elasticità e compattezza. Le linee d'espressione possono diventare più evidenti.",
            "La radiofrequenza viso è un trattamento estetico scelto da chi desidera prendersi cura di questi cambiamenti attraverso un percorso graduale, non invasivo e personalizzato.",
            "Il nostro obiettivo non è modificare i tratti naturali, ma sostenere l'aspetto della pelle, valorizzarne la compattezza e accompagnarla verso un aspetto più curato e disteso.",
        ],
    },
    how: {
        number: "02",
        eyebrow: "Come funziona",
        title: "Energia controllata, sensazione di calore graduale.",
        image: PHOTO.radioFrequenza,
        imageAlt: "Radiofrequenza viso",
        body: [
            "La radiofrequenza estetica utilizza energia controllata per generare calore negli strati cutanei interessati dal trattamento.",
            "Durante la seduta, il manipolo viene fatto scorrere sulle zone del viso attraverso movimenti regolari e graduali. La cliente percepisce una sensazione di calore progressivo, controllato durante tutta la procedura.",
            "Il trattamento non agisce come una procedura medica e non elimina definitivamente le rughe. Il suo obiettivo estetico è contribuire a migliorare l'aspetto generale della pelle.",
        ],
    },
    benefits: {
        eyebrow: "I benefici estetici",
        title: "Un rituale non invasivo per la pelle del viso.",
        subtitle:
            "I benefici possono variare da persona a persona e dipendono dalle condizioni iniziali della pelle e dalla costanza del percorso.",
        items: [
            {
                title: "Sostiene la tonicità della pelle",
                body: "Un supporto estetico nei percorsi dedicati alla tonicità cutanea, per accompagnare la pelle verso un aspetto più compatto e curato.",
            },
            {
                title: "Migliora l'aspetto delle rughe più marcate",
                body: "Il trattamento non cancella le rughe profonde, ma può renderne l'aspetto più armonioso all'interno di un percorso costante.",
            },
            {
                title: "Sostiene la compattezza dei contorni",
                body: "Le zone che mostrano una maggiore perdita di tono ricevono attenzione dedicata, per una sensazione visiva di maggiore uniformità.",
            },
            {
                title: "Graduale e non invasivo",
                body: "La seduta viene svolta senza aghi e senza interventi chirurgici. La sensazione di calore è controllata durante tutto il trattamento.",
            },
            {
                title: "Valorizza l'aspetto naturale",
                body: "Non proponiamo un'idea di bellezza artificiale. Vogliamo valorizzare la pelle e aiutare ogni donna a sentirsi più curata.",
            },
            {
                title: "Un percorso personalizzato",
                body: "Il numero e la frequenza delle sedute vengono valutati individualmente durante la consulenza, considerando le caratteristiche della pelle.",
            },
        ],
    },
    whenAdvised: {
        eyebrow: "Consigliata",
        title: "La radiofrequenza è il trattamento giusto per te?",
        subtitle:
            "Ogni pelle presenta caratteristiche diverse. Durante il primo incontro analizziamo lo stato della pelle e definiamo insieme un percorso costruito sui tuoi obiettivi.",
        cards: [
            {
                title: "Può essere indicata se…",
                list: [
                    "desideri prenderti cura delle rughe più evidenti;",
                    "vuoi migliorare la tonicità della pelle;",
                    "cerchi di contrastare l'aspetto di un viso rilassato;",
                    "vuoi sostenere la compattezza dei tessuti;",
                    "desideri iniziare un percorso anti-age non invasivo.",
                ],
            },
            {
                title: "Quando è consigliata una valutazione",
                body: "Segnala eventuali patologie della pelle, trattamenti dermatologici in corso o condizioni particolari. In presenza di dubbi potrà essere opportuno confrontarsi con il medico.",
            },
        ],
    },
    whyUs: {
        number: "03",
        eyebrow: "Perché Spazio Isa",
        title: "Ascolto, esperienza, trasparenza.",
        image: PHOTO.curaViso,
        imageAlt: "Trattamento viso Spazio Isa",
        body: [
            "Da oltre 15 anni Spazio Isa è un punto di riferimento a Livorno per chi desidera prendersi cura del proprio viso con trattamenti estetici professionali.",
            "Ogni seduta viene adattata alle esigenze della cliente, senza protocolli standard e con un approccio basato sull'ascolto, sull'esperienza e sulla trasparenza.",
            "Accompagniamo ogni cliente durante tutto il percorso, fornendo consigli personalizzati e suggerendo i prodotti cosmetici più adatti per proseguire la cura anche a casa.",
        ],
    },
    ctaTitle: "Prenota il tuo trattamento di radiofrequenza viso.",
    ctaSubtitle:
        "Durante la consulenza analizzeremo le caratteristiche della tua pelle e costruiremo insieme il percorso più adatto.",
    faq: [
        {
            q: "Che cos'è la radiofrequenza viso?",
            a: "Un trattamento estetico che utilizza energia a radiofrequenza per sostenere i percorsi dedicati alla tonicità e alla cura dell'aspetto delle rughe più evidenti.",
        },
        {
            q: "Elimina le rughe profonde?",
            a: "No. La radiofrequenza non elimina definitivamente le rughe profonde. È un trattamento estetico che può contribuire a migliorarne l'aspetto all'interno di un percorso personalizzato.",
        },
        {
            q: "Il trattamento è doloroso?",
            a: "Generalmente no. Durante la seduta si percepisce una piacevole sensazione di calore controllato.",
        },
        {
            q: "Quante sedute sono consigliate?",
            a: "Il numero dipende dalle caratteristiche della pelle, dagli obiettivi e dalla valutazione durante la consulenza iniziale.",
        },
        {
            q: "È adatta a tutti i tipi di pelle?",
            a: "La consulenza iniziale permette di valutare le condizioni della pelle e stabilire se il trattamento è indicato.",
        },
        {
            q: "Posso abbinarla ad altri trattamenti viso?",
            a: "Sì. Può essere inserita in un percorso estetico personalizzato insieme ad altri trattamenti proposti da Spazio Isa.",
        },
        {
            q: "Dove si trova Spazio Isa?",
            a: "In Via A. Minghi 30, nel quartiere Coteto, a Livorno.",
        },
    ],
    related: [
        { label: "Estetica", to: "/estetica" },
        { label: "Infrarossi", to: "/infrarossi" },
        { label: "Pressoterapia", to: "/pressoterapia" },
        { label: "Epilazione Laser", to: "/laser" },
        { label: "Prodotti", to: "/prodotti" },
        { label: "Contatti", to: "/contatti" },
    ],
};
